import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { FoljaForma, FoljaFormaPashtjelluar, FoljaKoha, FoljaMenyra } from '@core/enums/folja.enum';
import { FoljaFormaPashtjelluarConstants } from '@core/globals/folja/folja-forma-pashtjelluar.constants';
import { FoljaConstants } from '@core/globals/folja/folja.constants';
import { FoljaFormaPashtjelluarForCreationDTO } from '@core/interfaces/dto/folja-forma-pashtjelluar-for-creation-dto.interface';
import { FoljaBaza } from '@core/interfaces/models/folja-baza.interface';
import { EditorService } from '../editor.service';
import { FoljaFormaPashtjelluarFormulaService } from './folja-forma-pashtjelluar-formula.service';

@Injectable({
  providedIn: 'root',
})
export class FoljaFormaPashtjelluarService {
  constructor(private foljaFormaPashtjelluarFormulaService: FoljaFormaPashtjelluarFormulaService, private fb: UntypedFormBuilder) { }

  insertForms(foljaBaza: FoljaBaza, form: UntypedFormGroup) {
    let formArrays = ['foljaBaza.foljaFormaPashtjelluarInitial', 'foljaBaza.foljaFormaPashtjelluar'];
    for (let i = 0; i < formArrays.length; i++) {

      const formArray = form.get(formArrays[i]) as UntypedFormArray;
      this.generateFormaPashtjelluarForms(formArray);
      foljaBaza.foljaFormaPashtjelluar?.forEach((item) => {
        let index = formArray.controls.findIndex(
          (c) =>
            c.get('formaPashtjelluarId')?.value == item.formaPashtjelluarId &&
            c.get('kohaId')?.value == item.kohaId &&
            c.get('formaId')?.value == item.formaId &&
            c.get('pershkrimi')?.value == '' &&
            c.get('renditja')?.value == item.renditja
        );

        if (index != -1) {
          formArray.controls[index].get('pershkrimi')?.setValue(item.pershkrimi);
        } else {
          this.addNewLakimi(formArray, item.formaPashtjelluarId, item.kohaId, item.formaId, item.pershkrimi, item.renditja);
        }
      });
    }
  }

  generateForms(formArray: UntypedFormArray) {
    this.generateFormaPashtjelluarForms(formArray);
  }

  generateFormula(baza: string, foljaBaza: FoljaBaza, form: UntypedFormGroup) {
    this.foljaFormaPashtjelluarFormulaService.generateFormula(baza, foljaBaza, form.get('foljaBaza.foljaFormaPashtjelluar') as UntypedFormArray);
  }

  private generateFormaPashtjelluarForms(formArray: UntypedFormArray) {
    while (formArray.length > 0) {
      formArray.removeAt(0);
    }

    formArray.push(
      this.fb.group({
        kohaId: null,
        formaId: null,
        formaPashtjelluarId: FoljaFormaPashtjelluar.Pjesore,
        pershkrimi: '',
        renditja: 1
      })
    );

    for (const fk of FoljaFormaPashtjelluarConstants.FoljaFormaPashtjelluarKoha) {
      for (const ff of FoljaConstants.FoljaForma) {
        for (const ffp of FoljaConstants.FoljaFormaPashtjelluar.filter((p) => p.id != FoljaFormaPashtjelluar.Pjesore)) {
          const foljaForm = this.fb.group({
            kohaId: fk.id,
            formaId: ff.id,
            formaPashtjelluarId: ffp.id,
            pershkrimi: '',
            renditja: 1
          });

          formArray.push(foljaForm);
        }
      }
    }
  }

  addNewLakimi(formArray: UntypedFormArray, formaPashtjelluar: FoljaFormaPashtjelluar, koha?: FoljaKoha, forma?: FoljaForma, pershkrimi?: string, renditja?: number) {
    const renditjet = formArray.value.filter((c: any) => c.formaPashtjelluarId == formaPashtjelluar && c.kohaId == koha && c.formaId == forma).map((c: any) => c.renditja);
    const prevIndex = Math.max(...(renditjet.length > 0 ? renditjet : [0]));
    const foljaForm = this.fb.group({
      kohaId: koha,
      formaId: forma,
      formaPashtjelluarId: formaPashtjelluar,
      pershkrimi: pershkrimi,
      renditja: renditja ?? prevIndex + 1
    });
    formArray.push(foljaForm);
  }

  getCreationDTO(form: UntypedFormGroup) {
    const creationDTO: FoljaFormaPashtjelluarForCreationDTO[] = [];

    let formArray: UntypedFormArray;

    formArray = form.get('foljaBaza.foljaFormaPashtjelluar') as UntypedFormArray;

    const veproreParam = form.get('foljaBaza.veproreParam')?.value;
    const joveproreParam = form.get('foljaBaza.joveproreParam')?.value;

    let formArrayValue = formArray.getRawValue();

    if (!veproreParam) {
      formArrayValue = formArrayValue.filter((e: any) => e.formaId != FoljaForma.Veprore);
    }
    if (!joveproreParam) {
      formArrayValue = formArrayValue.filter((e: any) => e.formaId != FoljaForma.JoVeprore);
    }

    formArrayValue.forEach((e: any) => {
      creationDTO.push({
        formaId: e.formaId,
        kohaId: e.kohaId,
        formaPashtjelluarId: e.formaPashtjelluarId,
        pershkrimi: e.pershkrimi,
        renditja: e.renditja
      });
    });

    return creationDTO;
  }

  getErrors(foljaForm: UntypedFormGroup) {
    let errors: { menyraId: number; kohaId?: number; formaId?: number; formaPashtjelluarId: number, pershkrimi: string }[] = [];
    let initial = foljaForm.getRawValue().foljaFormaPashtjelluarInitial;
    let formula = foljaForm.getRawValue().foljaFormaPashtjelluar;

    const pjFmap = formula
      .filter((a: any) => a.formaId == null && a.kohaId == null && a.formaPashtjelluarId == FoljaFormaPashtjelluar.Pjesore)
      .map((a: any) => a.pershkrimi)
      .join(', ');

    const pjImap = initial
      .filter((a: any) => a.formaId == null && a.kohaId == null && a.formaPashtjelluarId == FoljaFormaPashtjelluar.Pjesore)
      .map((a: any) => a.pershkrimi)
      .join(', ');

    if (pjFmap != pjImap) {
      errors.push({
        menyraId: FoljaMenyra.Pashtjelluar,
        formaPashtjelluarId: FoljaFormaPashtjelluar.Pjesore,
        pershkrimi: pjImap
      });
    }

    for (const fk of FoljaFormaPashtjelluarConstants.FoljaFormaPashtjelluarKoha) {
      for (const ff of FoljaConstants.FoljaForma) {
        for (const ffp of FoljaConstants.FoljaFormaPashtjelluar.filter((p) => p.id != FoljaFormaPashtjelluar.Pjesore && p.id != FoljaFormaPashtjelluar.PaskajoreGege)) {

          const fmap = formula
            .filter((a: any) => a.formaId == ff.id && a.kohaId == fk.id && a.formaPashtjelluarId == ffp.id)
            .map((a: any) => a.pershkrimi)
            .join(', ');

          const imap = initial
            .filter((a: any) => a.formaId == ff.id && a.kohaId == fk.id && a.formaPashtjelluarId == ffp.id)
            .map((a: any) => a.pershkrimi)
            .join(', ');

          if (fmap != imap) {
            errors.push({
              menyraId: FoljaMenyra.Pashtjelluar,
              kohaId: fk.id,
              formaId: ff.id,
              formaPashtjelluarId: ffp.id,
              pershkrimi: imap
            });
          }
        }
      }
    }

    return errors;
  }
}
